/* unplugin-vue-components disabled */import script from "./BaseCheckBox.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseCheckBox.vue?vue&type=script&setup=true&lang=js"

import "./BaseCheckBox.vue?vue&type=style&index=0&id=32fc43fa&lang=css"

const __exports__ = script;

export default __exports__